import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'react-feather';
import { isBefore, isAfter, parseISO } from 'date-fns';

import Banner from '~/src/components/Banner';
import {
  isSubscriptionCanceled,
  useSubscription,
} from '~/src/entities/subscription';
import { getFormattedFullDateFromIsoString } from '~/src/utils/date';
import { canOrgUseFeatureAccess, getOrg } from '~/src/entities/user';
import { useStore } from '~/src/hooks/useMst';

const SubscriptionCancelationBannerContainer = () => {
  const { data } = useSubscription();
  const org = getOrg();
  const isCbsSubscription = canOrgUseFeatureAccess('CBS_INTEGRATION', org);
  const store = useStore();

  const { user } = store || {};

  if (!data) return null;

  if (!isSubscriptionCanceled(data)) return null;

  const initialIdentityReleaseDate = new Date('2025-06-04T14:00:00Z');
  const migrationWarning = !!user?.profile?.identityAuthenticated &&
    isBefore(parseISO(data.current_period_end), initialIdentityReleaseDate) && (
      <>
        <br />
        Did you recently set up your Clio Login and are not expecting this
        account? Contact <a href="mailto:support@clio.com">
          support@clio.com
        </a>{' '}
        for assistance.
      </>
    );

  const endDate = getFormattedFullDateFromIsoString(data.current_period_end);

  const description = isAfter(new Date(), parseISO(data.current_period_end))
    ? `Your subscription was canceled on ${endDate}`
    : `Your subscription is set to cancel on ${endDate}`;

  // Conditional text content based on subscription type
  const bannerContent = isCbsSubscription ? (
    <>{description}. Please contact Clio support for further assistance.</>
  ) : (
    <>
      {description}. Click{' '}
      <Link to="/settings/subscriptions">&nbsp;here&nbsp;</Link> to renew your
      subscription.
      {migrationWarning}
    </>
  );

  return (
    <Banner small alert fullWidth Icon={AlertCircle}>
      <div style={{ lineHeight: '1.8', marginLeft: '10px' }}>
        {bannerContent}
      </div>
    </Banner>
  );
};

export default SubscriptionCancelationBannerContainer;
